import React, { useEffect, useState } from 'react'
import './EditProduct.css'
import { useDispatch, useSelector } from 'react-redux';
import { addProductsData } from '../../features/addProducts/addProductsSlice';
import { editProductsData } from '../../features/editProduct/editProductSlice';

const EditProduct = () => {
    const dispatch = useDispatch();

    const data = useSelector
    ((state) => state.getProductById.data);
    const pending = useSelector((state) => state.getProductById.pending);
    const error = useSelector((state) => state.getProductById.error);
    const finalData = data.data;
    const [productDetails, setproductDetails] = useState({
        "title": "",
        "coinValue" : "",    
          
      });

      useEffect(() => {
        if (finalData) {
          setproductDetails(finalData);
        }
      }, [finalData]);
    

    const handleSubmit = async(e) => {
        e.preventDefault()
    
        const formData = new FormData()
        formData.append('productId',  finalData?._id);
        formData.append('title', productDetails?.title);
        formData.append('coinValue', productDetails?.coinValue);
        formData.append('file', productDetails?.file)

        dispatch(editProductsData(formData))
      .then((result) => {
        
       

        if(result?.payload?.response?.status=== 404){
          alert(result?.payload?.response?.data?.msg);
        }else if(result?.payload?.status=== true){
          window.location.href ='http://localhost:3000/admin/all-reward-products'
          alert(result?.payload?.msg)
        }
        console.log('Form submitted successfully!', result);
      //  window.location.reload()
        // Handle the result as needed
      })
      .catch((error) => {
        
        console.error('Form submission failed:', error.message);
        // Handle the error as needed
      });
    
      };

      const handleChange = (e) => {
        const { name, value } = e.target;
        // console.log(value);
        setproductDetails((prevData) => ({ ...prevData, [name]: value }));
      };

      const handleFileChange = (e)=>{
        // console.log(e.target)
        const image = e.target.files[0]
        setproductDetails
        ((prevFormData) => ({
        ...prevFormData, file : image
       
      }));
       
      }
    
    
  return (
    <div className='editProductWrapper'>
       
    <div className="editProductContainer">
      <h2 className="formTitle">Edit Product </h2>
      <form className="editProductForm" onSubmit={handleSubmit} encType="multipart/form-data">
        <label>
          Title:
          <input
            type="text"
            name="title"
            value={productDetails?.title}
            onChange={handleChange}
          />
        </label>
        <br />

        <label>
          Coin Value:
          <input
            type="number"
            name="coinValue"
            value={productDetails?.coinValue}
            onChange={handleChange}
          />
        </label>
        <br />
        <label className="fileUpload">
              Upload Files:
              <input
                type="file"
                name='files'
                accept="image/png, image/jpeg, image/gif, image/tiff, image/psd," 
                onChange={handleFileChange}
              />
            </label>
        <br />
        
        
        <button type="submit" className="editProductButton" > 
          Update Product
        </button>
      </form>
    </div>
  </div>
      

  )
}

export default EditProduct
